import React from 'react'
import { useMedia } from 'sb-hooks'

import { Image } from 'components/_new/ui'
import { Row, Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import s from './ProductInfo.scss'


type ProductInfoProps = {
  product: Review.Product
}

const ProductInfo: React.FunctionComponent<ProductInfoProps> = ({ product, children }) => {
  const { isMobile } = useMedia()
  const imageSize = isMobile ? 136 : 80

  return (
    <Row justify="start" align="center">
      <Image
        className={s.image}
        src={product.image}
        h={imageSize}
        x2
        x3
        placeholderWidth={imageSize}
        placeholderHeight={imageSize}
        resizeBy="width"
        alt={`${product.brand} ${product.name}`}
        dataTestId="productImage"
      />
      <Box ml={16} className={s.info}>
        <Text size={isMobile ? '18-24' : '16-20'} semibold message={product.brand} dataTestId="productBrand" />
        <Box mt={isMobile ? 4 : null}>
          <Text size={isMobile ? '16-24' : '16-20'} message={product.name} dataTestId="productName" />
        </Box>
        {children}
      </Box>
    </Row>
  )
}


export default ProductInfo
